export default "__VITE_ASSET__CSLMyQHG__"